import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from './Header';
import BottomNavigation from './BottomNavigation';
import theMissingHourData from '../story/the-missing-hour/characters_data.json';

// SVG Icons for ContactDetail
function PhoneIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="nav-svg">
      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
    </svg>
  );
}

function MessagesIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="nav-svg">
      <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
    </svg>
  );
}

function ContactDetail() {
  const { contactId } = useParams();
  const navigate = useNavigate();
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load character data from the imported JSON file
    try {
      const character = theMissingHourData.characters.find(char => char.id === contactId);
      
      if (character) {
        setContact({
          id: character.id,
          name: character.name,
          department: character.role.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
          initial: character.name.split(' ')[0][0],
          photo: character.profile_photo,
          relation: character.connection_to_victim,
          description: character.background,
          role: character.role,
          involvement_days: character.involvement_days || [],
          status: character.status || 'active'
        });
      } else {
        console.error('Contact not found:', contactId);
      }
    } catch (error) {
      console.error('Error loading contact data:', error);
    } finally {
      setLoading(false);
    }
  }, [contactId]);

  const handleBack = () => {
    navigate('/contacts');
  };

  if (loading) {
    return (
      <div className="contact-detail-container">
        <Header showBackButton={true} onBack={handleBack} />
        <div className="loading-container">
          <p>Loading contact details...</p>
        </div>
      </div>
    );
  }

  if (!contact) {
    return (
      <div className="contact-detail-container">
        <Header showBackButton={true} onBack={handleBack} />
        <div className="error-container">
          <p>Contact not found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-detail-container">
      <Header 
        showBackButton={true}
        onBack={handleBack}
      />
      
      <div className="contact-detail-content">
        <div className="contact-detail-photo">
          {contact.photo && contact.photo.startsWith('/story/') ? (
            <img src={contact.photo} alt={contact.name} className="contact-photo" />
          ) : (
            <div className="contact-initial-large">{contact.initial}</div>
          )}
        </div>
        
        <h1 className="contact-detail-name">{contact.name}</h1>
        
        <div className="contact-detail-department">
          <span className="field-label">DEPARTMENT:</span>
          <span className="field-value">{contact.department}</span>
        </div>
        
        <div className="contact-detail-relation">
          <span className="field-label">CONNECTION TO VICTIM:</span>
          <p>{contact.relation}</p>
        </div>
        
        <div className="contact-detail-description">
          <h3>Background</h3>
          <p>{contact.description}</p>
        </div>

        {contact.involvement_days && contact.involvement_days.length > 0 && (
          <div className="contact-detail-involvement">
            <span className="field-label">CASE INVOLVEMENT:</span>
            <span className="field-value">Day {contact.involvement_days.join(', ')}</span>
          </div>
        )}
        
        <div className="contact-detail-actions">
          <button className="detail-action-btn call-btn">
            <PhoneIcon />
            Call
          </button>
          <button className="detail-action-btn message-btn">
            <MessagesIcon />
            Message
          </button>
        </div>
      </div>

      <BottomNavigation showNavigation={true} />
    </div>
  );
}

export default ContactDetail;
